/**
 * @generated SignedSource<<6b99c82eb9e9f885607d3dd5d53ea4bb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type CartChannel = "businessshop" | "personalshop" | "personalss" | "sparkdigitalshop";
export type MpdChangePlanComparisonQuery$variables = {
  channel: CartChannel;
  lineNumber: string;
  addOffer: string;
};
export type MpdChangePlanComparisonQuery$data = {
  readonly changePlanMpdComparison: {
    readonly cartId: string;
    readonly bundles: ReadonlyArray<{
      readonly lineNumber: string | null;
      readonly id: string;
      readonly items: ReadonlyArray<{
        readonly productOfferingId: string;
        readonly name: string;
        readonly action: string;
        readonly price: {
          readonly priceType: string;
          readonly period: string;
          readonly basePrice: number;
          readonly effectivePrice: number;
          readonly discount: {
            readonly discountType: string | null;
            readonly appliedValue: number | null;
          } | null;
        } | null;
      }>;
    }> | null;
    readonly existingPlans: ReadonlyArray<{
      readonly lineNumber: string | null;
      readonly productOfferingId: string;
      readonly name: string;
      readonly currentPrice: {
        readonly priceType: string;
        readonly period: string;
        readonly basePrice: number;
        readonly effectivePrice: number;
        readonly discount: {
          readonly discountType: string | null;
          readonly appliedValue: number | null;
        } | null;
      };
      readonly updatedPrice: {
        readonly priceType: string;
        readonly period: string;
        readonly basePrice: number;
        readonly effectivePrice: number;
        readonly discount: {
          readonly discountType: string | null;
          readonly appliedValue: number | null;
        } | null;
      };
    }> | null;
    readonly discountPercentageChanged: boolean;
  };
};
export type MpdChangePlanComparisonQuery = {
  variables: MpdChangePlanComparisonQuery$variables;
  response: MpdChangePlanComparisonQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "addOffer"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "channel"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "lineNumber"
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lineNumber",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "productOfferingId",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "priceType",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "period",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "basePrice",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "effectivePrice",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "PlansMpdComparisonDiscount",
    "kind": "LinkedField",
    "name": "discount",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "discountType",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "appliedValue",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v7 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "addOffer",
        "variableName": "addOffer"
      },
      {
        "kind": "Variable",
        "name": "channel",
        "variableName": "channel"
      },
      {
        "kind": "Variable",
        "name": "lineNumber",
        "variableName": "lineNumber"
      }
    ],
    "concreteType": "PlansMpdComparisonResponse",
    "kind": "LinkedField",
    "name": "changePlanMpdComparison",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cartId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "PlansMpdComparisonBundle",
        "kind": "LinkedField",
        "name": "bundles",
        "plural": true,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PlansMpdComparisonItem",
            "kind": "LinkedField",
            "name": "items",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "action",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PlansMpdComparisonPrice",
                "kind": "LinkedField",
                "name": "price",
                "plural": false,
                "selections": (v6/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "PlansMpdComparisonExistingPlan",
        "kind": "LinkedField",
        "name": "existingPlans",
        "plural": true,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "PlansMpdComparisonPrice",
            "kind": "LinkedField",
            "name": "currentPrice",
            "plural": false,
            "selections": (v6/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PlansMpdComparisonPrice",
            "kind": "LinkedField",
            "name": "updatedPrice",
            "plural": false,
            "selections": (v6/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "discountPercentageChanged",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "MpdChangePlanComparisonQuery",
    "selections": (v7/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "MpdChangePlanComparisonQuery",
    "selections": (v7/*: any*/)
  },
  "params": {
    "cacheID": "9b40431fe48ae6d0ac262a637932d9f8",
    "id": null,
    "metadata": {},
    "name": "MpdChangePlanComparisonQuery",
    "operationKind": "query",
    "text": "query MpdChangePlanComparisonQuery(\n  $channel: CartChannel!\n  $lineNumber: String!\n  $addOffer: String!\n) {\n  changePlanMpdComparison(channel: $channel, lineNumber: $lineNumber, addOffer: $addOffer) {\n    cartId\n    bundles {\n      lineNumber\n      id\n      items {\n        productOfferingId\n        name\n        action\n        price {\n          priceType\n          period\n          basePrice\n          effectivePrice\n          discount {\n            discountType\n            appliedValue\n          }\n        }\n      }\n    }\n    existingPlans {\n      lineNumber\n      productOfferingId\n      name\n      currentPrice {\n        priceType\n        period\n        basePrice\n        effectivePrice\n        discount {\n          discountType\n          appliedValue\n        }\n      }\n      updatedPrice {\n        priceType\n        period\n        basePrice\n        effectivePrice\n        discount {\n          discountType\n          appliedValue\n        }\n      }\n    }\n    discountPercentageChanged\n  }\n}\n"
  }
};
})();

(node as any).hash = "89b902706d31a71b4f41bae2c316a50a";

export default node;
